export default "__VITE_ASSET__DkvrWuCR__"